import * as Phoenix from 'phoenix'
import env from '../config/environment'

export default token => {
    const params = { token }

    var socket = new Phoenix.Socket(env.socket_url, { params });
    socket.onError(function () { socket.params = params });
    socket.connect();

    var eventHandlers = {};
    var eventHandlersIds = new Map();

    var channels = {};
    var getChannel = function (name, params) {
        return new Promise(function (resolve, reject) {
            if (channels[name]) {
                if (channels[name].then)
                    channels[name].then(resolve).catch(reject);
                else
                    resolve(channels[name]);
            } else {
                channels[name] = new Promise(function (resolveInner, reject) {
                    var channel = socket.channel(name);
                    channel.join(params)
                        .receive("ok", function () {
                            channels[name] = channel;
                            eventHandlers[name] = new Map();
                            resolveInner(channel);
                            resolve(channel)
                        })
                        .receive("error", reject)
                        .receive("timeout", function () { reject("timeout") });
                })
            }
        });
    };

    return {
        getSocket: function () {
            return socket
        },
        push: function (channel, message, payload) {
            return getChannel(channel).then(function (channel) {
                return new Promise(function (resolve, reject) {
                    channel.push(message, payload)
                        .receive("ok", resolve)
                        .receive("error", reject)
                        .receive("timeout", function () { reject("timeout") })
                })
            })
        },
        on: function (channel, event, callback) {
            var handlerId = parseInt(Math.random() * 1000000000).toString();

            eventHandlersIds.set(handlerId, { event: event, channel: channel });

            getChannel(channel).then(function (channel) {
                var handlers = eventHandlers[channel.topic].get(event) || new Map();
                handlers.set(handlerId, callback);
                eventHandlers[channel.topic].set(event, handlers);

                channel.off(event);
                channel.on(event, function (payload) {
                    eventHandlers[channel.topic]
                        .get(event)
                        .forEach(function (handler) {
                            handler(payload)
                        });
                });
            });

            return handlerId
        },
        off: function (handlerId) {
            var handlerData = eventHandlersIds.get(handlerId) || {};
            var event = handlerData.event;
            var channel = handlerData.channel;

            if (eventHandlers[channel] && eventHandlers[channel].has(event)) {
                var handlers = eventHandlers[channel].get(event);
                handlers.delete(handlerId);

                if (handlers.size == 0) {
                    getChannel(channel).then(function (channel) {
                        channel.off(event);
                    })
                }
            }
        },
        disconnect: () => socket.disconnect()
    }
}
